export const EVENT_NAMES = {
  RATE: 'Rate Heatmap',
  INSTALL_TRACKING_CODE: 'Install Tracking Code',
  CREATE_HEATMAP: 'Save Heatmap',
  REMOVE_HEATMAP: 'Remove Heatmap',
  EDIT_HEATMAP: 'Edit Heatmap',
  OPEN_HEATMAP: 'Open Heatmap',
  HEATMAP_ACCURATE: 'Heatmap Accurate',
  HEATMAP_INACCURATE: 'Heatmap Inaccurate',
  GENERAL_SURVEY: 'General Survey',
  SHARE_LINK: 'Short Link Heatmaps',
  HM_DOES_NOT_LOOK_RIGHT: 'Heatmap Does Not Look Right',
  HM_NOT_CAPTURING_URL: 'Heatmap Not Capturing Url',
  HM_SHOWS_COOKIES_BANNER: 'Heatmap Shows Cookies Banner',
  HM_DOES_NOT_LOOK_RIGHT_RETAKER: 'Heatmap Does Not Look Right Retaker',
  HM_NOT_CAPTURING_URL_RETAKER: 'Heatmap Not Capturing Url Retaker',
  HM_SHOWS_COOKIES_BANNER_RETAKER: 'Heatmap Shows Cookies Banner Retaker',
  FEEDBACK_CARD: 'Feedback Card',
  TOP_CLICKS_WIDGET: 'Top Clicks Widget',
  ERROR_WIDGET_VIEW_RECORDINGS_LIST: 'View Recordings - Error Widget',
  ERROR_WIDGET_VIEW_TRENDS: 'View Trends - Error Widget',
  MAGIC_RULER_AVERAGE_FOLD: 'Average Fold Marker Hovered',
  MAGIC_RULER_75_MARKER: '75% Marker Hovered',
  MAGIC_RULER_50_MARKER: '50% Marker Hovered',
  MAGIC_RULER_25_MARKER: '25% Marker Hovered',
  MAGIC_RULER_MARKER_HIGHER_THAN_FOLD: 'Scroll Marker Higher Than Average Fold Detected',
  MAGIC_RULER_MARKERS_OVERLAP: 'Markers Overlap Detected',
  TOGGLED_ON: 'Toggled On',
  TOGGLED_OFF: 'Toggled Off',
  ENGAGEMENT_ZONES_MORE_INSIGHTS: 'Engagement Zones Learn More',
};
